import React, { useContext } from 'react'
import { Box } from '@hub/box'
import { Tab } from '@hub/tabs'
import { LinkContext } from '../../../context'

interface TabItemListProps {
  tabName: string
  selectedColour: string
  url?: string
}

export const TabItemList: React.FC<TabItemListProps> = ({
  tabName,
  selectedColour,
  url,
}) => {
  const Link = useContext(LinkContext)
  const Component = url ? Box : Tab

  return (
    <Component
      as={url ? props => <Link to={url} {...props} /> : undefined}
      _selected={{
        bg: 'smoke',
        fontWeight: 'bold',
        borderTopColor: selectedColour,
        color: 'licorice',
      }}
      sx={{
        flexGrow: 1,
        borderWidth: '2px',
        color: 'quartz',
        fontSize: 'font-tiny',
        fontWeight: 'bold',
        paddingX: 'spacing-md',
        paddingY: 'spacing-sm',
        borderRightRadius: '2px',
        borderLeftRadius: '2px',
        borderBottomRadius: 0,
        borderTopStyle: 'solid',
        borderTopColor: 'transparent',
        lineHeight: 'base',
        whiteSpace: 'nowrap',
        textAlign: 'center',
      }}
    >
      {tabName}
    </Component>
  )
}
